import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { maskActions } from "@actions";

const Loading = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(maskActions.toggleMask(true));

    return () => dispatch(maskActions.toggleMask(false));
  }, [dispatch]);

  return <div>Loading......</div>;
};

export default Loading;
